'use client';

import { ClickAwayListener } from '@mui/material';
import { cloneElement, useCallback } from 'react';

import { usePopperContext } from './hooks';

import type { ClickAwayListenerProps } from '@mui/material';
import type { FC, ReactElement } from 'react';

export interface PopperOnClickCloseProps {
  children: ReactElement;
}

export const PopperClickAwayClose: FC<PopperOnClickCloseProps> = ({
  children,
  ...props
}) => {
  const { handleClose } = usePopperContext();

  return (
    <ClickAwayListener onClickAway={handleClose}>
      {cloneElement( children, {
        onClick: handleClose,
        ...props,
      } )}
    </ClickAwayListener>
  );
};
